import * as z from "zod";

export const disputeEvidenceSchema_ = z.object({
  id: z.coerce.bigint(),
  disputeId: z.coerce.bigint(),
  /** @deprecated use activityLog */
  accessActivityLog: z.string().nullish(),
  customerCommunicationFileUrl: z.string().nullish(),
  invalidDisputeReason: z.string().nullish(),
  /** @deprecated use summary_file_url */
  uncategorizedFileUrl: z.string().nullish(),
  activityLog: z.string().nullish(),
  cancellationPolicyDisclosure: z.string().nullish(),
  cancellationRebuttal: z.string().nullish(),
  refundPolicyDisclosure: z.string().nullish(),
  refundRefusalExplanation: z.string().nullish(),
  productDescription: z.string().nullish(),
  cancellationPolicyFileUrl: z.string().nullish(),
  refundPolicyFileUrl: z.string().nullish(),
  serviceDocumentationFileUrl: z.string().nullish(),
  shippingDocumentationFileUrl: z.string().nullish(),
  affidavitFileUrl: z.string().nullish(),
  billingAgreementFileUrl: z.string().nullish(),
  orderDetailsFileUrl: z.string().nullish(),
  termsAcceptanceFileUrl: z.string().nullish(),
  summaryFileUrl: z.string().nullish(),
  trackingInfo: z.unknown().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export const disputeEvidenceSchema: z.ZodType<DisputeEvidence> =
  disputeEvidenceSchema_;
export interface DisputeEvidence extends z.infer<
  typeof disputeEvidenceSchema_
> {}

export interface UpsertDisputeEvidenceInput {
  disputeId: bigint;
  accessActivityLog?: string | null;
  customerCommunicationFileUrl?: string | null;
  invalidDisputeReason?: string | null;
  uncategorizedFileUrl?: string | null;
  activityLog?: string | null;
  cancellationPolicyDisclosure?: string | null;
  cancellationRebuttal?: string | null;
  refundPolicyDisclosure?: string | null;
  refundRefusalExplanation?: string | null;
  productDescription?: string | null;
  cancellationPolicyFileUrl?: string | null;
  refundPolicyFileUrl?: string | null;
  serviceDocumentationFileUrl?: string | null;
  shippingDocumentationFileUrl?: string | null;
  affidavitFileUrl?: string | null;
  billingAgreementFileUrl?: string | null;
  orderDetailsFileUrl?: string | null;
  termsAcceptanceFileUrl?: string | null;
  summaryFileUrl?: string | null;
  trackingInfo?: unknown | null;
}
